import { createSlice } from '@reduxjs/toolkit';

export const patientSlice = createSlice({
  name: 'patient',
  initialState: {
    patient: null,
    selectedSerchPat: null,
  },
  reducers: {
    setPatient: (state, action) => {
      state.patient = action.payload;
    },
    setSeltSerchPat: (state, action) => {
      state.selectedSerchPat = action.payload;
    },
  },
});

export const { setPatient, setSeltSerchPat } = patientSlice.actions;
export default patientSlice.reducer;
